module.exports = __webpack_public_path__ + "static/img/钛白粉.92dc619.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/钛白粉.jpg
// module id = 193
// module chunks = 1